import {
  getUnregisteredShopsData,
  getUnregisteredShopDetailData
} from '../libs/apis/UnregisteredShopApi';

export const GET_UNREGISTERED_SHOPS_REQUEST = 'GET_UNREGISTERED_SHOPS_REQUEST';
export const GET_UNREGISTERED_SHOPS_SUCCESS = 'GET_UNREGISTERED_SHOPS_SUCCESS';
export const GET_UNREGISTERED_SHOPS_FAILURE = 'GET_UNREGISTERED_SHOPS_FAILURE';

export const GET_UNREGISTERED_SHOP_DETAIL_REQUEST =
  'GET_UNREGISTERED_SHOP_DETAIL_REQUEST';
export const GET_UNREGISTERED_SHOP_DETAIL_SUCCESS =
  'GET_UNREGISTERED_SHOP_DETAIL_SUCCESS';
export const GET_UNREGISTERED_SHOP_DETAIL_FAILURE =
  'GET_UNREGISTERED_SHOP_DETAIL_FAILURE';

export const getUnregisteredShops = () => dispatch => {
  dispatch({ type: GET_UNREGISTERED_SHOPS_REQUEST });
  return getUnregisteredShopsData()
    .then(response =>
      dispatch({
        type: GET_UNREGISTERED_SHOPS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_UNREGISTERED_SHOPS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getUnregisteredShopDetail = unregisteredShopId => dispatch => {
  dispatch({ type: GET_UNREGISTERED_SHOP_DETAIL_REQUEST });
  return getUnregisteredShopDetailData(unregisteredShopId)
    .then(response =>
      dispatch({
        type: GET_UNREGISTERED_SHOP_DETAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_UNREGISTERED_SHOP_DETAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
